import { styled } from 'styled-components';

import { cssBreakpoints } from '#/theme/theme';

export const CoursesAd_Box_1 = styled.div`
  margin-top: 25px;
`;

export const CoursesAd_Box_2 = styled.div`
  padding-bottom: 32px;
  margin-top: 14px;

  @media all and (min-width: ${cssBreakpoints.xsUp}) {
    padding-left: 15px;
    padding-bottom: 10px;
    margin-top: 0;
  }
`;
